import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Layout({ children }) {
  const location = useLocation();
  const [isInIframe, setIsInIframe] = useState(false);

  useEffect(() => {
    // Check if the app is running inside an iframe
    setIsInIframe(window.self !== window.top);
  }, []);

  const isActive = (path) => location.pathname === path;

  return (
    <div className="min-h-screen text-white" style={{ backgroundColor: '#1D353C' }}>
      <header className="flex items-center justify-between gap-4 p-6 bg-black/20 backdrop-blur-md flex-wrap">
        <div className="flex items-center gap-4">
          <img src="/images/logo.png" alt="Inbox Sentinel" className="h-12 rounded" />
          <Link to="/" className="text-decoration-none text-white">
            <h1 className="m-0 text-3xl font-bold">Inbox Sentinel</h1>
          </Link>
        </div>
        <nav className="flex gap-6 flex-wrap">
          <Link
            to="/"
            className={`text-white text-base font-medium transition-opacity ${
              isActive('/') ? 'opacity-100 font-bold border-b-2 border-white pb-0.5' : 'opacity-80'
            }`}
          >
            Home
          </Link>
          {isInIframe && (
            <>
              <Link
                to="/dashboard"
                className={`text-white text-base font-medium transition-opacity ${
                  isActive('/dashboard') ? 'opacity-100 font-bold border-b-2 border-white pb-0.5' : 'opacity-80'
                }`}
              >
                Dashboard
              </Link>
              <Link
                to="/settings"
                className={`text-white text-base font-medium transition-opacity ${
                  isActive('/settings') ? 'opacity-100 font-bold border-b-2 border-white pb-0.5' : 'opacity-80'
                }`}
              >
                Settings
              </Link>
            </>
          )}
          <Link
            to="/install"
            className={`text-white text-base font-medium transition-opacity ${
              isActive('/install') ? 'opacity-100 font-bold border-b-2 border-white pb-0.5' : 'opacity-80'
            }`}
          >
            Install
          </Link>
          <Link
            to="/docs"
            className={`text-white text-base font-medium transition-opacity ${
              isActive('/docs') ? 'opacity-100 font-bold border-b-2 border-white pb-0.5' : 'opacity-80'
            }`}
          >
            Docs
          </Link>
          <Link
            to="/support"
            className={`text-white text-base font-medium transition-opacity ${
              isActive('/support') ? 'opacity-100 font-bold border-b-2 border-white pb-0.5' : 'opacity-80'
            }`}
          >
            Support
          </Link>
          <Link
            to="/privacy"
            className={`text-white text-base font-medium transition-opacity ${
              isActive('/privacy') ? 'opacity-100 font-bold border-b-2 border-white pb-0.5' : 'opacity-80'
            }`}
          >
            Privacy
          </Link>
          <Link
            to="/terms-conditions"
            className={`text-white text-base font-medium transition-opacity ${
              isActive('/terms-conditions') ? 'opacity-100 font-bold border-b-2 border-white pb-0.5' : 'opacity-80'
            }`}
          >
            Terms
          </Link>
        </nav>
      </header>
      <main className="max-w-4xl mx-auto px-8 py-12">
        {children}
      </main>
      <footer className="text-center p-8 border-t border-white/20 mt-16 text-sm opacity-70">
        <p>&copy; 2026 Inbox Sentinel. All rights reserved.</p>
        <p>Inbox Sentinel is a Marketplace app protecting email conversations from spam.</p>
        <p>
          <a href="mailto:inbox.sentinel@hello.miltonecom.com" className="text-white hover:underline">
            inbox.sentinel@hello.miltonecom.com
          </a>
          {' | '}
          <a href="tel:+18662593033" className="text-white hover:underline">
            +1 (866) 259-3033
          </a>
        </p>
      </footer>
    </div>
  );
}
